import { ChangeEvent, useState } from "react";

export const useFilter = (initialText = "") => {
  const [filterText, setFilterText] = useState(initialText);

  const handleFilter = ({ currentTarget }: ChangeEvent<HTMLInputElement>) =>
    setFilterText(currentTarget.value?.toLowerCase() || "");

  return {
    filterText,
    onFilter: handleFilter,
  };
};
